import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ErrorMessage, Field } from "formik";

import {
  setNumberOfPrivateAccidentInsuranceData,
  setComprehensiveInsuranceData,
  setIncreasedTravelProtectionInsuranceData,
  setPersonalAccidentInsuranceData,
  setTentantInsuranceData,
  setSmallBoatsInsuranceData,
  getApartmentInsuranceName,
  setPrivateInsuranceData,
  setAdditionalJewelryInsurance
} from "../../reducers/apartmentAction";

import NumberPrivateAccicentInsurances from '../../JSON/NumberPrivateAccicentInsurances'

class ApartmentInsuranceCard extends Component {

  setAdditionalJewelryInsurance(value) {
    this.props.setAdditionalJewelryInsurance(value);
    this.props.setFieldValue('selected_additional_jewelry_insurance', value);
  }

  numberOfPrivateAccidentInsurance(nr) {
    this.props.setNumberOfPrivateAccidentInsuranceData(nr);
    this.props.setFieldValue("privateAccidentInsurance", nr);
  }

  setComprehensiveInsurance(bool) {
    this.props.setComprehensiveInsuranceData({ bool });
    this.props.setFieldValue("comprehensiveInsurance", bool);
  }
  
  setIncreasedTravelProtection(bool) {
    this.props.setIncreasedTravelProtectionInsuranceData({ bool });
    this.props.setFieldValue('increasedTravelProtection', bool);
  }

  setPersonalAccidentInsurance(bool) {
    this.props.setPersonalAccidentInsuranceData({ bool });
    this.props.setFieldValue('personalAccidentInsurance', bool);
  }

  setTenantInsurance(bool) {
    this.props.setTentantInsuranceData({ bool });
    this.props.setFieldValue('tentantInsurance', bool);
  }

  setSmallBoatsInsurance(bool) {
    this.props.setSmallBoatsInsuranceData({ bool });
    this.props.setFieldValue('smallBoatsInsurance', bool);
  }

  selectedPersonalAccidentInsurances (bool) {
    if(bool) {
      return (<div className="col-md-12">
        <div className="form-group">
          <label htmlFor="numberOfPrivateAccidentInsurance">Antal personer som ska ha privatolycksfallsförsäkring *</label>
          <div className="dropdown" id="custom-select" tabIndex="0">
            <div type="text" className="custom-select-dd" id="numberOfPrivateAccidentInsurance" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
              <span> {this.props.values.privateAccidentInsurance ? this.props.values.privateAccidentInsurance.name : "Välj personer"} </span>
            </div>

            <div className="dropdown-menu custom-dropdown" aria-labelledby="numberOfPrivateAccidentInsurance" >
              {NumberPrivateAccicentInsurances.map(nr => (
                <div className="dropdown-item" onClick={() => this.numberOfPrivateAccidentInsurance(nr)} key={nr.key} >
                  {nr.name}
                </div>
              ))}
            </div>
            <Field name="privateAccidentInsurance" type="hidden" className={ "form-control" + (this.props.errors.privateAccidentInsurance && this.props.touched.privateAccidentInsurance ? " is-invalid" : "") } />
            <ErrorMessage name="privateAccidentInsurance" component="div" className="invalid-feedback" />
      
          </div>
        </div>
      </div>)
    }
  }

  render() {
    
    const firstInsurance = this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 0).length > 0 ? (
      <div className="col-md-6">
        <div className="custom-control custom-checkbox mr-1">
          <input
            type="checkbox"
            className="custom-control-input"
            onChange={() => this.setComprehensiveInsurance( !this.props.comprehensive_insurance ) }
            id="checkbox1"
            checked={this.props.comprehensive_insurance}
          />
          <label className="custom-control-label" htmlFor="checkbox1">
            {getApartmentInsuranceName(0)}
          </label>
          <Field name="comprehensiveInsurance" type="hidden" className="form-control" />
        </div>
        <br />
      </div>
    ) : null;

    const secondInsurance = this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 1).length > 0 ? (
      <div className="col-md-6">
        <div className="custom-control custom-checkbox mr-1">
          <input
            type="checkbox"
            className="custom-control-input"
            onChange={() => this.setPersonalAccidentInsurance( !this.props.personal_accident_insurance ) }
            id="checkbox3"
            checked={this.props.personal_accident_insurance}
          />
          <label className="custom-control-label" htmlFor="checkbox3">
            {getApartmentInsuranceName(1)}
          </label>
          <Field name="personalAccidentInsurance" type="hidden" className="form-control" />
        </div>
        <br />
      </div>
    ) : "";

    const thirdInsurance = this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 2).length > 0 ? (
      <div className="col-md-6">
        <div className="custom-control custom-checkbox mr-1">
          <input
            type="checkbox"
            className="custom-control-input"
            onChange={() => this.setIncreasedTravelProtection( !this.props.increased_travel_protection ) }
            id="checkbox2"
            checked={this.props.increased_travel_protection}
          />
          <label className="custom-control-label" htmlFor="checkbox2">
            {getApartmentInsuranceName(2)}
          </label>
          <Field name="increasedTravelProtectionInsurance" type="hidden" className="form-control" />
        </div>
        <br />
      </div>
    ) : null;

    const fourthInsurance = this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 3).length > 0 ? (
      <div className="col-md-6">
        <div className="custom-control custom-checkbox mr-1">
          <input
            type="checkbox"
            className="custom-control-input"
            onChange={() => this.setTenantInsurance( !this.props.tenant_insurance ) }
            id="checkbox4"
            checked={this.props.tenant_insurance}
          />
          <label className="custom-control-label" htmlFor="checkbox4">
            {getApartmentInsuranceName(3)}
          </label>
          <Field name="tentantInsurance" type="hidden" className="form-control" />
        </div>
        <br />
      </div>
    ) : "";

    const fifthInsurance = this.props.additionalInsurance.filter((e) => e.additionalInsuranceType === 4).length > 0 ? (
      <div className="col-md-6">
        <div className="custom-control custom-checkbox mr-1">
          <input
            type="checkbox"
            className="custom-control-input"
            onChange={() => this.setSmallBoatsInsurance( !this.props.small_boats_insurance ) }
            id="checkbox5"
            checked={this.props.small_boats_insurance}
          />
          <label className="custom-control-label" htmlFor="checkbox5">
          {getApartmentInsuranceName(4)}
          </label>
          <Field name="smallBoatsInsurance" type="hidden" className="form-control" />
        </div>
        <br />
      </div>
    ) : "";
    
    return (
      <div className="card">
        <div className="card-header">Tilläggsförsäkringar</div>
        
        <div className="card-body">
          
          { firstInsurance }
          { secondInsurance }
          { thirdInsurance }
          { fourthInsurance }
          { fifthInsurance }

          <br />

          { this.selectedPersonalAccidentInsurances(this.props.personal_accident_insurance) }

          {
            // Person 1
            (this.props.selected_number_personal_accident_insurances > 0) ?
              (<div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                    <label htmlFor="privateInsurancePersonSsn1">Personnummer (person 1)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonSsn1" type="text"
                          onBlur={e => {
                            this.props.handleBlur(e);
                            this.props.setPrivateInsuranceData({
                              first_personal_accident_insurances_ssn: e.target.value
                            });
                        }}
                        className={ "form-control" + (this.props.errors.privateInsurancePersonSsn1 && this.props.touched.privateInsurancePersonSsn1 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonSsn1" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                    <label>Namn (person 1)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonName1" type="text" placeholder=""
                          onBlur={e => { this.props.handleBlur(e); this.props.setPrivateInsuranceData({
                            first_personal_accident_insurances_name: e.target.value
                          });
                        }} 
                        className={ "form-control" + (this.props.errors.privateInsurancePersonSsn1 && this.props.touched.privateInsurancePersonSsn1 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonName1" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : null
          }

          {
            // Person 2
            (this.props.selected_number_personal_accident_insurances > 1) ?
              (<div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                    <label htmlFor="privateInsurancePersonSsn2">Personnummer (person 2)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonSsn2" type="text"
                          onBlur={e => {
                            this.props.handleBlur(e);
                            this.props.setPrivateInsuranceData({
                              second_personal_accident_insurances_ssn: e.target.value
                            });
                        }}
                        className={ "form-control" + (this.props.errors.privateInsurancePersonSsn2 && this.props.touched.privateInsurancePersonSsn2 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonSsn2" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                    <label>Namn (person 2)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonName2" type="text" placeholder=""
                          onBlur={e => { this.props.handleBlur(e); this.props.setPrivateInsuranceData({
                            second_personal_accident_insurances_name: e.target.value
                          });
                        }} 
                        className={ "form-control" + (this.props.errors.privateInsurancePersonName2 && this.props.touched.privateInsurancePersonName2 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonName2" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : null
          }

          {
            // Person 3
            (this.props.selected_number_personal_accident_insurances > 2) ?
              (<div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                    <label htmlFor="privateInsurancePersonSsn3">Personnummer (person 3)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonSsn3" type="text"
                          onBlur={e => {
                            this.props.handleBlur(e);
                            this.props.setPrivateInsuranceData({
                              third_personal_accident_insurances_ssn: e.target.value
                            });
                        }}
                        className={ "form-control" + (this.props.errors.privateInsurancePersonSsn3 && this.props.touched.privateInsurancePersonSsn3 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonSsn3" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                    <label>Namn (person 3)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonName3" type="text" placeholder=""
                          onBlur={e => { this.props.handleBlur(e); this.props.setPrivateInsuranceData({
                            third_personal_accident_insurances_name: e.target.value
                          });
                        }} 
                        className={ "form-control" + (this.props.errors.privateInsurancePersonName3 && this.props.touched.privateInsurancePersonName3 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonName3" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : null
          }

          {
            // Person 4
            (this.props.selected_number_personal_accident_insurances > 3) ?
              (<div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                    <label htmlFor="privateInsurancePersonSsn4">Personnummer (person 4)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonSsn4" type="text"
                          onBlur={e => {
                            this.props.handleBlur(e);
                            this.props.setPrivateInsuranceData({
                              fourth_personal_accident_insurances_ssn: e.target.value
                            });
                        }}
                        className={ "form-control" + (this.props.errors.privateInsurancePersonSsn4 && this.props.touched.privateInsurancePersonSsn4 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonSsn4" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                    <label>Namn (person 4)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonName4" type="text" placeholder=""
                          onBlur={e => { this.props.handleBlur(e); this.props.setPrivateInsuranceData({
                            fourth_personal_accident_insurances_name: e.target.value
                          });
                        }} 
                        className={ "form-control" + (this.props.errors.privateInsurancePersonName4 && this.props.touched.privateInsurancePersonName4 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonName4" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : null
          }

          {
            // Person 4
            (this.props.selected_number_personal_accident_insurances > 3) ?
              (<div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                    <label htmlFor="privateInsurancePersonSsn5">Personnummer (person 5)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonSsn5" type="text"
                          onBlur={e => {
                            this.props.handleBlur(e);
                            this.props.setPrivateInsuranceData({
                              fifth_personal_accident_insurances_ssn: e.target.value
                            });
                        }}
                        className={ "form-control" + (this.props.errors.privateInsurancePersonSsn5 && this.props.touched.privateInsurancePersonSsn5 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonSsn5" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                    <label>Namn (person 5)*</label>
                      <div className="input-group">
                        <Field name="privateInsurancePersonName5" type="text" placeholder=""
                          onBlur={e => { this.props.handleBlur(e); this.props.setPrivateInsuranceData({
                            fifth_personal_accident_insurances_name: e.target.value
                          });
                        }} 
                        className={ "form-control" + (this.props.errors.privateInsurancePersonName5 && this.props.touched.privateInsurancePersonName5 ? " is-invalid" : "")
                      }
                        />
                        <ErrorMessage name="privateInsurancePersonName5" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : null
          }

          <div className="col-md-12">
            <div className="form-group">
              <label>Smycken och armbandsklockor*</label>
              <p>Högsta ersättningsbelopp för smycken och armbandsklockor är 200 000 kr.<br />
              Vill du att försäkringen ska gälla för högre värde?</p>
              <div className="btn-group btn-group-stretch" data-toggle="buttons">
                <label className={"btn " + (this.props.selected_additional_jewelry_insurance && this.props.selected_additional_jewelry_insurance != null ? "active" : "")} onClick={() => this.setAdditionalJewelryInsurance(true)}>
                    <input type="radio" onChange={this.setJewelryInsurance} name="options"
                            id="option1" autoComplete="off" /> Ja, kontakta mig
                </label>
                <label className={"btn " + (!this.props.selected_additional_jewelry_insurance && this.props.selected_additional_jewelry_insurance != null ? "active" : "")} onClick={()  => this.setAdditionalJewelryInsurance(false)}>
                    <input type="radio" onChange={this.setJewelryInsurance} name="options"
                            id="option2" autoComplete="off"/> Nej, 200 000 kr räcker som ersättningsbelopp
                </label>
              </div>
              <Field name="selected_additional_jewelry_insurance" type="hidden"
                  className={'form-control' + (this.props.errors.selected_additional_jewelry_insurance && this.props.touched.selected_additional_jewelry_insurance ? ' is-invalid' : '')}/>
              <ErrorMessage name="selected_additional_jewelry_insurance" component="div" className="invalid-feedback"/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    privateAccidentInsurance: state.apartmentReducer.number_personal_accident_insurances,
    selected_number_personal_accident_insurances: state.apartmentReducer.apartment_information.selected_number_personal_accident_insurances,
    comprehensive_insurance: state.apartmentReducer.apartment_information.comprehensive_insurance,
    increased_travel_protection: state.apartmentReducer.apartment_information.increased_travel_protection,
    personal_accident_insurance: state.apartmentReducer.apartment_information.personal_accident_insurance,
    tenant_insurance: state.apartmentReducer.apartment_information.tenant_insurance,
    small_boats_insurance: state.apartmentReducer.apartment_information.small_boats_insurance,
    first_personal_accident_insurances: state.apartmentReducer.apartment_information.first_personal_accident_insurances,
    second_personal_accident_insurances: state.apartmentReducer.apartment_information.second_personal_accident_insurances,
    third_personal_accident_insurances: state.apartmentReducer.apartment_information.third_personal_accident_insurances,
    fourth_personal_accident_insurances: state.apartmentReducer.apartment_information.fourth_personal_accident_insurances,
    fifth_personal_accident_insurances: state.apartmentReducer.apartment_information.fifth_personal_accident_insurances,
    selected_additional_jewelry_insurance: state.apartmentReducer.apartment_information.selected_additional_jewelry_insurance,

    customerSection: state.simpleReducer.customerSection,
    additionalInsurance: state.simpleReducer.additionalInsurance,
    attachments: state.simpleReducer.attachments
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setNumberOfPrivateAccidentInsuranceData: bindActionCreators(setNumberOfPrivateAccidentInsuranceData, dispatch),
    setComprehensiveInsuranceData: bindActionCreators(setComprehensiveInsuranceData, dispatch),
    setIncreasedTravelProtectionInsuranceData: bindActionCreators(setIncreasedTravelProtectionInsuranceData,dispatch),
    setPersonalAccidentInsuranceData: bindActionCreators(setPersonalAccidentInsuranceData, dispatch),
    setTentantInsuranceData: bindActionCreators(setTentantInsuranceData, dispatch),
    setSmallBoatsInsuranceData: bindActionCreators(setSmallBoatsInsuranceData, dispatch),
    setPrivateInsuranceData: bindActionCreators(setPrivateInsuranceData, dispatch),
    setAdditionalJewelryInsurance: bindActionCreators(setAdditionalJewelryInsurance, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApartmentInsuranceCard);
